export default __webpack_public_path__ + "static/consistent-header-guest-1e38dbc9264dddaa00fccea5671d2653.png";